/* @flow */

import { DateTime } from 'luxon';
import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { isString } from '@e180/util/lib/type';

import useTimeFormat from './hook/useTimeFormat';
import { formatTime } from 'src/shared/app/base/date/util/dateFormatters';

type Props = {
  date: DateTime | string,
  id?: string,
  withLocalZone?: boolean,
};

// E.g. 1:30 PM or 13:30
const Time = ({ date: propDate, id, withLocalZone }: Props): React.Node => {
  const date: DateTime = isString(propDate)
    ? DateTime.fromISO(propDate)
    : propDate;

  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const { locale } = useIntl();
  const timeFormat = useTimeFormat();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const txt = formatTime(date, locale, timeFormat, !!withLocalZone);

  return (
    <time id={id} dateTime={date.toISO()} aria-label={txt}>
      {txt}
    </time>
  );
};

export default compose(React.memo)(Time);
